import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  Icon,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import { LinearProgressWithLabel } from 'components';
import { deleteCustomerImportQueueTaskApi } from 'api';
import { useStyles } from './styles';


const CustomersImportProgress = ({headers, customerGroups, isCustomer3}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [progress, setProgress] = useState(0);
  const [failedTasks, setFailedTasks] = useState([]);

  const {
    customersImportQueue,
    countOfCreatedQueueTasks,
    customerImportFileName
  } = useSelector((state: IReduxState) => state.customers);

  useEffect(() => {
    const countOfTasksInProgress = customersImportQueue.length;
    const remainingTasks = countOfCreatedQueueTasks - countOfTasksInProgress;
    const progress = (remainingTasks * 100) / countOfCreatedQueueTasks;
    setProgress(progress);

    const failedTasks = customersImportQueue.filter((task) => task.status === 'FAILED');
    setFailedTasks(failedTasks);

    if (failedTasks.length === countOfTasksInProgress) {
      setProgress(100);
    }
  }, [customersImportQueue]);

  const handleDeleteCustomerImportTaskFromQueue = (id) => {
    deleteCustomerImportQueueTaskApi({dispatch, id});
  };

  return (
    <div className="p-10">
      {progress !== 100 &&
        <>
          <div className="text-muted flex">
            <div className="mr-1">{'Customers Import'}</div>
            {!!customerImportFileName.length &&
              <div className="mr-1">
                {'from '}
                <strong>{`${customerImportFileName} `}</strong>
                {'is '}
              </div>
            }
            <div>{'In Progress...'}</div>
          </div>
          <LinearProgressWithLabel value={progress} />
          <p className="text-muted font-bold uppercase">
            {`Total: ${countOfCreatedQueueTasks - customersImportQueue.length}/${countOfCreatedQueueTasks}`}
          </p>
        </>
      }
      {!!failedTasks.length &&
        <Card className="mt-5 p-7">
          <Typography className="mb-5">
            <strong className="text-error mr-1">Failed import data.</strong>
            <span className="text-muted">You need to resolve all errors before start new import.</span>
          </Typography>
          <Table className={classes.tableRoot}>
            <TableHead>
              <TableRow>
                <TableCell width="60px" align="center">{'#'}</TableCell>
                {headers.split(',').map((i) => (
                  <TableCell key={`header-${i}`}>{i}</TableCell>
                ))}
                <TableCell>Error</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {failedTasks.map((task, index) => {
                const {
                  firstname,
                  lastname,
                  dob,
                  email,
                  gender,
                  group_id,
                  custom_attributes
                } = task.body.customer;

                const phoneNumber = custom_attributes.find(
                  (attr) => attr.attribute_code === 'phone_number'
                )?.value || '';

                const practiceName = custom_attributes.find(
                  (attr) => attr.attribute_code === 'practice_name'
                )?.value || '';

                const groupCode = customerGroups.find((g) => g.id === group_id)?.code || '';

                const genderMap = {
                  1: 'male',
                  2: 'female',
                  3: ''
                };

                return (
                  <TableRow key={`failed-task-${index}`}>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell>{firstname}</TableCell>
                    <TableCell>{lastname}</TableCell>
                    <TableCell>{email}</TableCell>
                    <TableCell>{phoneNumber}</TableCell>
                    <TableCell>{genderMap[gender]}</TableCell>
                    <TableCell>{dob}</TableCell>
                    {isCustomer3 &&
                      <TableCell>{practiceName}</TableCell>
                    }
                    <TableCell>{groupCode}</TableCell>
                    <TableCell>
                      <div
                        title={task.error.message}
                        className="ellipsis"
                      >
                        {task.error.message}
                      </div>
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => handleDeleteCustomerImportTaskFromQueue(task._id)}
                        title="Delete"
                      >
                        <Icon fontSize="small">delete</Icon>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Card>
      }
    </div>
  );
};

export default CustomersImportProgress;
